import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import request, { tracesToken } from "../../lib/requester";
import axios from "axios";
import { DownloadOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { Loader } from "react-overlay-loader";

class Attachments extends Component {
  static propTypes = {
    data: PropTypes.object,
    claim_id: PropTypes.string,
  };

  static defaultProps = {
    data: {},
    claim_id: "",
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  renderDocument = () => {
    return this.props.data.docsContainer.map((item, index) => (
      <div className="row" key={index}>
        <div className="col-md-12">
          <i className="fa fa-check text-success" />
          &nbsp;{item.document_name}
        </div>
      </div>
    ));
  };

  renderLink = () => {
    return this.props.data.docs.map((item, index) => (
      <div className="col-md-12" key={index}>
        <i className="fa fa-file-pdf text-danger" />
        &nbsp;{" "}
        <a
          style={{ color: "blue" }}
          onClick={() => this.downloadAttachment(item, "preview")}
        >
          {item.doc === "mandatory"
            ? this.props.data.claimNumber.replace(/[/]/g, "")
            : item.filename}
        </a>
        <Button
          type="primary"
          icon={<DownloadOutlined />}
          className="ml-3"
          onClick={() => this.downloadAttachment(item)}
        />
      </div>
    ));
  };

  downloadAttachment = (data, preview) => {
    this.setState({ loading: true });
    let url =
      data.doc === "bupot"
        ? `/api/traces/v1/tracking-email/download-surat-refund?bupot_file_key=${data.key}&bupot_filename=${data.filename}`
        : data.doc === "mandatory"
        ? `/api/traces/v1/tracking-email/download-surat-refund?mandatory_filename=${data.filename}&mandatory_file_key=${data.key}`
        : `/api/traces/v1/tracking-email/download-surat-refund?additional_FileName=${data.filename}&mandatory_file_key=${data.key}`;

    request.getTraces(url, {
      success: function (response) {
        if (response.data.statusCode === 400) {
          window.open(data.path, "_blank");
          this.setState({ loading: false });
        } else {
          axios({
            url: response.config.url,
            method: "GET",
            responseType: "blob",
            headers: {
              Authorization: `Bearer ${tracesToken()}`,
            },
          })
            .then((response) => {
              if (preview && preview === "preview") {
                const objectUrl = URL.createObjectURL(response.data);
                const pdfWindow = window.open();
                pdfWindow.location.href = objectUrl;
                // window.open(response.config.url, "_blank");
                this.setState({ loading: false });
              } else {
                const href = URL.createObjectURL(response.data);
                const link = document.createElement("a");
                link.href = href;
                link.setAttribute(
                  "download",
                  data.doc === "bupot"
                    ? `CLAIM_${data.claim_id}.pdf`
                    : data.doc === "mandatory"
                    ? `${data.claim_number.replace(/[/]/g, "")}.pdf`
                    : `${data.filename}.pdf`
                );
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(href);
                this.setState({ loading: false });
              }
            })
            .catch((error) => {
              window.open(data.path, "_blank");
              this.setState({ loading: false });
            });
        }
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
      }.bind(this),
    }); 
  };

  render() {
    return (
      <Fragment>
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header bg-light font-size-title font-weight-bold">
                Attachments
              </div>
              <div className="multi-collapse show" id="multiCollapseExample2">
                <div className="card-body">
                  <div className="row mb-3">
                    <div className="col-md-6">{this.renderDocument()}</div>
                    <div className="col-md-6">{this.renderLink()}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Loader fullPage loading={this.state.loading} />
      </Fragment>
    );
  }
}

export default Attachments;
